import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ORIENTATION } from 'cards/types';

interface FoldProps {
  height: number;
  width: number;
  pageOrientation: string;
}

const caculateDeg = (height: number, width: number, outside: number) => {
  const len = Math.sqrt(height ** 2 + width ** 2) / 2;
  return Math.atan(outside / len);
};

export const Fold = styled.div<FoldProps>`
  background-color: @gray-lighter;
  background-image: linear-gradient(170deg, rgba(135, 135, 135, 0.15), rgba(135, 135, 135, 0.02));
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  position: absolute;

  ${({ pageOrientation, height, width }) => {
    if (pageOrientation === ORIENTATION.landscape) {
      return css`
        height: ${height - 12}pt;
        right: -10pt;
        top: 0;
        transform: skewX(${caculateDeg(height - 12, 30, 10)}rad);
        width: 30pt;
      `;
    }
    return css`
      height: 100pt;
      right: 10pt;
      top: -10pt;
      transform: skewY(-${caculateDeg(width - 12, 30, 10)}rad);
      width: ${width - 12}pt;
    `;
  }};
`;
